import { Component } from 'react';
import { Alert, Button, Card, Form, Image, InputGroup, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { DarkElectricBlue, GammaBlue, White } from '../../helpers/brand_colors_helper';
import { t } from '../../helpers/translation_helper';
import { GET, POST } from '../../api';
import { getUrlParam } from '../../helpers/general_helpers';
import GetIcon from '../../helpers/icon_helper';

const createSessionURL = 'payment-gateway-streampay/create-session';
const verifyPaymentURL = 'payment-gateway-streampay/verify-payment';

class PaymentGatewayStreampay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      creatingSession: false,
      verifying: false,
      paymentStatusResult: null,
      balance: 0,
      formCheckOut: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
      },
    };
  }

  componentDidMount() {
    if (this.props.params) {
      const nameParts = (this.props.params.parent_name || '').trim().split(' ');
      const firstName = nameParts[0] || '';
      const lastName = nameParts.slice(1).join(' ') || (this.props.params.child_name || '');

      this.setState({
        balance: this.props.params.balance || 0,
        formCheckOut: {
          firstName: firstName || 'Parent',
          lastName: lastName || 'Account',
          email: this.props.params.email || this.props.params.email1 || '',
          phone: this.props.params.mobile || this.props.params.phone || '0500000000',
        },
      });
    }

    const urlParams = getUrlParam();
    const orderId = urlParams.orderId || urlParams.order_id;
    const paymentId = urlParams.payment_id || urlParams.id;
    const invoiceId = urlParams.invoice_id;
    const status = urlParams.status;

    if (orderId || paymentId || invoiceId || status) {
      this.verifyPayment(orderId, paymentId, invoiceId, urlParams);
    }
  }

  verifyPayment = async (orderId, paymentId, invoiceId, urlParams = {}) => {
    this.setState({ processing: true, verifying: true });
    try {
      const res = await GET(verifyPaymentURL, {
        params: {
          orderId: orderId || this.props.params?.orderId,
          payment_id: paymentId,
          invoice_id: invoiceId,
          center_id: urlParams.center_id || this.props.params?.center_id,
          user_id: urlParams.user_id || this.props.params?.user_id,
          child_id: urlParams.child_id || this.props.params?.child_id,
          parent_id: urlParams.parent_id || this.props.params?.parent_id,
          tenant_id: this.props.tenant_id,
        },
      });
      const resData = res ? res.data : null;
      if (resData) {
        this.setState({ paymentStatusResult: resData, processing: false, verifying: false });
      } else {
        toast.error(t('Could not verify payment status.'));
        this.setState({ processing: false, verifying: false });
      }
    } catch (err) {
      toast.error(t('Could not verify payment status.'));
      this.setState({ processing: false, verifying: false });
    }
  };

  createSession = async () => {
    const amountToPay = this.state.balance || this.props.params?.balance;
    const { formCheckOut } = this.state;

    if (!amountToPay || amountToPay <= 0) {
      toast.error(t('Amount is required!'));
      return;
    }
    if (!formCheckOut.firstName) {
      toast.error(t('First Name is required!'));
      return;
    }

    this.setState({ creatingSession: true, processing: true });

    try {
      const fData = new FormData();
      fData.append('amount', amountToPay);
      fData.append('data', JSON.stringify({
        ...formCheckOut,
        child_id: this.props.params?.child_id,
        parent_id: this.props.params?.parent_id,
      }));

      const paramsToSend = {
        tenant_id: this.props.tenant_id,
        center_id: this.props.params?.center_id,
        parent_id: this.props.params?.parent_id,
        child_id: this.props.params?.child_id,
        user_id: this.props.params?.user_id,
        actionType: this.props.params?.actionType,
        addservicesheader_id: this.props.params?.addservicesheader_id,
      };

      const res = await POST(createSessionURL, fData, { params: paramsToSend });
      const resData = res ? res.data : null;

      if (!resData || !resData.type) {
        toast.error(resData?.message || t('Could not initialize StreamPay checkout.'));
        this.setState({ creatingSession: false, processing: false });
        return;
      }

      const redirectUrl = resData.redirect_url || resData.data?.url;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        toast.error(t('No checkout URL received from payment gateway.'));
        this.setState({ creatingSession: false, processing: false });
      }
    } catch (err) {
      toast.error(t('Could not start the payment form. Please refresh and try again.'));
      this.setState({ creatingSession: false, processing: false });
    }
  };

  submitPayment = (e) => {
    if (e) e.preventDefault();
    const { processing, creatingSession } = this.state;
    if (processing || creatingSession) return;
    this.createSession();
  };

  render() {
    const { params } = this.props;
    const { formCheckOut, creatingSession, processing, verifying, paymentStatusResult } = this.state;
    const busy = creatingSession || processing;

    if (verifying) {
      return (
        <Card className="border-0" style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
          <Card.Body className="text-center p-5">
            <Spinner animation="grow" variant="dark" className="mb-3" />
            <div style={{ color: DarkElectricBlue, fontSize: 18, fontWeight: 600 }}>
              {t('Verifying payment status, please wait...')}
            </div>
          </Card.Body>
        </Card>
      );
    }

    if (paymentStatusResult) {
      const isSuccess = paymentStatusResult.type;
      const resData = paymentStatusResult.data || {};
      return (
        <Card className="border-0" style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
          <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
            <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>
              {t(paymentStatusResult.messageTitle || 'Payment Status')}
            </div>
          </Card.Header>
          <Card.Body className="text-center">
            <div className="my-3">
              <GetIcon
                icon={isSuccess ? 'LuBadgeCheck' : 'LuBadgeAlert'}
                style={{ fontSize: 60, color: isSuccess ? '#28a745' : '#dc3545' }}
              />
            </div>
            <h5 className="mb-3" style={{ color: isSuccess ? '#28a745' : '#dc3545', fontWeight: 600 }}>
              {t(paymentStatusResult.message)}
            </h5>
            <Table borderless striped className="text-start mt-4">
              <tbody>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>Order ID</th>
                  <td style={{ textAlign: 'left' }}>{resData.orderId || '-'}</td>
                </tr>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>Payment Ref</th>
                  <td style={{ textAlign: 'left' }}>{resData.paymentId || resData.invoiceId || '-'}</td>
                </tr>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>Amount</th>
                  <td style={{ textAlign: 'left' }}>{(params?.balance || '-') + ' ' + (params?.currencycode || 'SAR')}</td>
                </tr>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>Status</th>
                  <td style={{ textAlign: 'left' }}>
                    <span className={`badge ${isSuccess ? 'bg-success' : 'bg-danger'}`}>
                      {isSuccess ? 'PAID' : 'FAILED'}
                    </span>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
          <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
            <Button
              variant={isSuccess ? 'success' : 'primary'}
              style={{ width: '100%' }}
              onClick={() => {
                window.location.href = window.location.origin + window.location.pathname;
              }}
            >
              {isSuccess ? t('Done') : t('Try Again')}
            </Button>
          </Card.Footer>
        </Card>
      );
    }

    return (
      <Card className="border-0" style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
        <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
          <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>
            {t('StreamPay Checkout')}
          </div>
        </Card.Header>
        <Card.Body>
          <Table borderless striped>
            <thead>
              <tr>
                <th style={{ fontSize: 16, textAlign: 'center', color: DarkElectricBlue }} colSpan={2}>
                  {t('Summary')}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th style={{ textAlign: 'center', width: '50%' }}>{t('Parent Name')}</th>
                <td style={{ textAlign: 'left' }}>{params?.parent_name}</td>
              </tr>
              <tr>
                <th style={{ textAlign: 'center', width: '50%' }}>{t('Student Name')}</th>
                <td style={{ textAlign: 'left' }}>{params?.child_name}</td>
              </tr>
              <tr>
                <th style={{ textAlign: 'center', width: '50%' }}>{t('Amount Due')}</th>
                <td style={{ textAlign: 'left' }}>{params?.balance + ' ' + params?.currencycode}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={2} style={{ textAlign: 'center' }}>
                  <div className="d-flex flex-row align-items-center justify-content-center">
                    <Image src={require('../../assets/payment-methods/mada.png')} style={{ height: 45, marginLeft: 5, marginRight: 5 }} />
                    <Image src={require('../../assets/payment-methods/visacard.png')} style={{ height: 45, marginLeft: 5, marginRight: 5 }} />
                    <Image src={require('../../assets/payment-methods/mastercard.png')} style={{ height: 45, marginLeft: 5, marginRight: 5 }} />
                    <Image src={require('../../assets/payment-methods/american-express.png')} style={{ height: 45, marginLeft: 5, marginRight: 5 }} />
                  </div>
                </td>
              </tr>
            </tfoot>
          </Table>

          <Alert variant="info" className="my-3 text-center" style={{ fontSize: 13 }}>
            <GetIcon icon="LuBadgeInfo" style={{ marginRight: 6 }} />
            {t('You will be redirected to StreamPay secure hosted checkout to complete your payment with Mada, Credit Card, or Apple Pay.')}
          </Alert>

          <Table borderless striped>
            <tbody>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('First Name')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.firstName}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, firstName: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('Last Name')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.lastName}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, lastName: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('Email')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.email}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, email: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('Phone')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="05XXXXXXXX"
                      value={formCheckOut.phone}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, phone: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>

        <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
          <Form onSubmit={this.submitPayment}>
            <Button variant="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
              <div className="d-flex flex-row justify-content-center align-items-center">
                {busy && <Spinner animation="grow" variant="dark" className="mx-1" />}
                <div className="mx-1">{t('Proceed to StreamPay')}</div>
                <div className="mx-1" style={{ fontWeight: 600 }}>{params?.currencycode}</div>
                <div className="mx-1 px-2" style={{ backgroundColor: White, borderRadius: 20, color: GammaBlue, fontWeight: 600 }}>
                  {params?.balance}
                </div>
              </div>
            </Button>
          </Form>
        </Card.Footer>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  langLabels: state.language.langLabels,
});

const mapDispatchToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps())(PaymentGatewayStreampay);